/**
 * Removes symbols from a phone number.
 *
 * @param {string} s The phone number containing symbols
 * @return {string}
 */
export const stripPhoneNumberSymbols = (s: string) => {
  return s.replace(/\(|\)|-| /gi, "");
};

/**
 * Formats a phone number either 7 or 10 digits long.
 * Defaults to returning the original string.
 *
 * Supported formats:
 *    1234567    => 123-4567
 *    1234567890 => (123) 4567-890
 *
 * @param {string} s The phone number string
 * @return {string}
 */

export function formatPhoneNumber(s: string) {
  const n = stripPhoneNumberSymbols(s);

  if (n.length === 7) {
    return `${n.substring(0, 3)}-${n.substring(3, 7)}`;
  }

  if (n.length === 10) {
    return `(${n.substring(0, 3)}) ${n.substring(3, 6)}-${n.substring(6, 11)}`;
  }

  return s;
}
